import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../components/AuthProvider';

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const API = `${BACKEND}/api`;

export default function useShipments() {
  const { user } = useAuth();
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (signal) => {
    if (!user) {
      setShipments([]);
      return;
    }
    try {
      setLoading(true);
      const res = await axios.get(`${API}/shipments`, signal ? { signal } : undefined);
      setShipments(res.data);
    } catch (err) {
      if (!axios.isCancel(err)) {
        console.error('Error loading shipments:', err);
      }
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    const controller = new AbortController();
    load(controller.signal);
    return () => controller.abort();
  }, [load]);

  return { shipments, loading, reload: load, setShipments };
}
